import React, { useState } from "react"
import { useDispatch } from "react-redux"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSync } from "@fortawesome/free-solid-svg-icons"
import { changePassword } from "../../store/actions/navActions"
import { showToast } from "../../store/actions/toastActions"
import { COLORS } from "../../utilities/Constants"

const FIELDS = [
	{ key: "current_password", label: "Mot de passe actuel" },
	{ key: "new_password", label: "Nouveau mot de passe" },
	{ key: "confirm_password", label: "Confirmer le nouveau" },
]

const styles = {
	screen: {
		position: "fixed",
		inset: 0,
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		backgroundColor: COLORS.bg,
		zIndex: 5000,
		padding: 20,
		fontFamily: "'DM Sans', sans-serif",
	},
	card: {
		backgroundColor: COLORS.surface,
		borderRadius: 16,
		boxShadow: "0 10px 40px rgba(28, 25, 23, 0.12)",
		padding: "32px 28px",
		width: "100%",
		maxWidth: 380,
	},
	title: { fontSize: 20, fontWeight: 600, color: COLORS.text, margin: "0 0 6px" },
	subtitle: {
		fontSize: 13,
		color: COLORS.textLight,
		margin: "0 0 22px",
		lineHeight: 1.5,
	},
	field: { marginBottom: 14 },
	label: {
		display: "block",
		fontSize: 12,
		fontWeight: 500,
		color: COLORS.textMuted,
		marginBottom: 6,
	},
	input: {
		width: "100%",
		padding: "10px 12px",
		borderRadius: 10,
		border: `1px solid ${COLORS.border}`,
		fontSize: 14,
		fontFamily: "inherit",
		boxSizing: "border-box",
		outline: "none",
	},
	submit: (disabled) => ({
		width: "100%",
		marginTop: 8,
		padding: "11px 20px",
		borderRadius: 10,
		border: "none",
		backgroundColor: COLORS.text,
		color: "#FFFFFF",
		fontSize: 14,
		fontWeight: 500,
		fontFamily: "inherit",
		cursor: disabled ? "not-allowed" : "pointer",
		opacity: disabled ? 0.5 : 1,
	}),
	logout: {
		display: "block",
		width: "100%",
		marginTop: 14,
		background: "none",
		border: "none",
		color: COLORS.textLight,
		fontSize: 13,
		cursor: "pointer",
		fontFamily: "inherit",
	},
}

const ForcePasswordChange = ({ onLogout }) => {
	const dispatch = useDispatch()
	const [form, setForm] = useState({
		current_password: "",
		new_password: "",
		confirm_password: "",
	})
	const [submitting, setSubmitting] = useState(false)
	const update = (k, v) => setForm((p) => ({ ...p, [k]: v }))

	const invalid =
		!form.current_password ||
		form.new_password.length < 8 ||
		form.new_password !== form.confirm_password

	const submit = () => {
		if (form.new_password !== form.confirm_password) {
			dispatch(
				showToast(
					"warning",
					"Les nouveaux mots de passe ne correspondent pas.",
				),
			)
			return
		}
		if (form.new_password.length < 8) {
			dispatch(showToast("warning", "8 caractères minimum."))
			return
		}
		setSubmitting(true)
		// Au succès, le flag tombe (clearMustChangePassword) → App démonte cet écran.
		dispatch(changePassword(form)).then((ok) => {
			if (!ok) setSubmitting(false)
		})
	}

	return (
		<div style={styles.screen}>
			<div style={styles.card}>
				<h2 style={styles.title}>Changez votre mot de passe</h2>
				<p style={styles.subtitle}>
					Première connexion : choisissez un nouveau mot de passe (8
					caractères minimum) pour accéder à l'application.
				</p>
				{FIELDS.map((f) => (
					<div key={f.key} style={styles.field}>
						<label style={styles.label}>{f.label}</label>
						<input
							type="password"
							style={styles.input}
							value={form[f.key]}
							onChange={(e) => update(f.key, e.target.value)}
							onKeyDown={(e) =>
								e.key === "Enter" && !invalid && submit()
							}
						/>
					</div>
				))}
				<button
					style={styles.submit(submitting || invalid)}
					onClick={submit}
					disabled={submitting || invalid}
				>
					{submitting ? (
						<FontAwesomeIcon icon={faSync} spin />
					) : (
						"Valider"
					)}
				</button>
				<button style={styles.logout} onClick={onLogout}>
					Se déconnecter
				</button>
			</div>
		</div>
	)
}

export default ForcePasswordChange
